import { fokaAxios } from 'app/fokaAxios'

const { get, post } = fokaAxios

export default {
  getRegisteredKeywords: texts =>
    post('/api/v2/keywords/registed', {
      texts,
    }),
  getPredictKeywords: keywordAndPrices =>
    post('/api/v2/recommend-keywords/planner/predict', {
      keywords: keywordAndPrices,
    }),
  searchKeywords: keyword =>
    get('/api/v2/recommend-keywords', {
      params: {
        q: keyword.replace(/\s+/g, ''),
      },
    }),
  getBiddingAverages: keywords =>
    post('/api/v2/recommend-keywords/bidding/average', {
      keywords,
    }),
}
